

import React from "react";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { Routes, Route, useLocation } from "react-router-dom";

import BottomNav from "./components/BottomNav";
import PrivateRoute from "../src/components/auth/PrivateRoute"; // ⬅️ Import it

import HomePage from "./pages/HomePage";
import CalendarPage from "./pages/CalendarPage";
import ProfilePage from "./pages/ProfilePage";
import LoginPage from "./pages/LoginPage";
import TaskPage from "./pages/TaskPage";
import DailyTaskPage from "./pages/Task/DailyTaskPage";
import TaskApprovalPage from "./pages/Task/TaskApprovalPage";
import DailyTaskPageAttendanceModalPage from "./pages/Task/DailyTaskPageAttendanceModalPage";
import AttendanceReport from "./pages/AttendanceReport";
import LeavePage from "./pages/LeavePage";
import ApplyLeave from "./pages/Leave/ApplyLeave";
import LeaveDetails from "./pages/Leave/LeaveDetails";

const AppWrapper = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  const hideBottomNavPaths = ["/login", "/"];
  const showBottomNav = user && !hideBottomNavPaths.includes(location.pathname);

  return (
    <div className="h-screen h-[100dvh] flex flex-col">
      <Toaster position="top-right" toastOptions={{ duration: 3000 }} />

      <div className="flex-1 overflow-auto">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Private Routes */}
          <Route
            path="/home"
            element={
              <PrivateRoute>
                <HomePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/calendar"
            element={
              <PrivateRoute>
                <CalendarPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/tasks"
            element={
              <PrivateRoute>
                <TaskPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/daily-task"
            element={
              <PrivateRoute>
                <DailyTaskPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/task-approval"
            element={
              <PrivateRoute>
                <TaskApprovalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/daily-task-attendance"
            element={
              <PrivateRoute>
                <DailyTaskPageAttendanceModalPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/attendance-Report"
            element={
              <PrivateRoute>
                <AttendanceReport />
              </PrivateRoute>
            }
          />
          <Route
            path="/leave"
            element={
              <PrivateRoute>
                <LeavePage />
              </PrivateRoute>
            }
          />
          <Route
            path="/leave/apply"
            element={
              <PrivateRoute>
                <ApplyLeave />
              </PrivateRoute>
            }
          />
          <Route
            path="/leave/details"
            element={
              <PrivateRoute>
                <LeaveDetails />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>

      {/* BottomNav only after login */}
      {showBottomNav && (
        <div className="flex-shrink-0">
          <BottomNav />
        </div>
      )}
    </div>
  );
};

export default AppWrapper;
